import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";
import { cn } from "../utils";

export interface TooltipProps extends TooltipPrimitive.TooltipContentProps {
  label: React.ReactNode;
  children: React.ReactNode;
  delayDuration?: number;
}

export function Tooltip({ label, children, className, sideOffset = 6, delayDuration = 200, ...props }: TooltipProps) {
  const triggerChild = React.isValidElement(children) ? children : <span className="inline-flex items-center">{children}</span>;

  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{triggerChild}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            sideOffset={sideOffset}
            className={cn(
              "z-50 rounded-md bg-neutral-900 px-3 py-1.5 text-xs text-white shadow-lg",
              "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=delayed-open]:fade-in data-[state=closed]:fade-out",
              className
            )}
            {...props}
          >
            {label}
            <TooltipPrimitive.Arrow className="fill-neutral-900" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
